// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function SquareStackDashed(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "SquareStackDashed" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M4 6H2V22H18V20H4V6Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6 8.5H8V11.5H6V8.5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M20 8.5H22V11.5H20V8.5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M12.5 2H15.5V4H12.5V2Z", fill: "currentColor" }),
            React.createElement("path", { d: "M12.5 16H15.5V18H12.5V16Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6 2V6H8V4H10V2H6Z", fill: "currentColor" }),
            React.createElement("path", { d: "M22 18V14H20V16H18V18H22Z", fill: "currentColor" }),
            React.createElement("path", { d: "M22 2L18 2V4H20V6H22V2Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6 18H10V16L8 16V14H6L6 18Z", fill: "currentColor" }))));
});
//# sourceMappingURL=SquareStackDashed.js.map